import { instance } from "../../axios";

export const getAnalyticStudies = async (user) => {
  if (!user?.id) {
    return [];
  }

  let url = "/study";

  if (user.organization === "Center" && user.role === "manager") {
    url = `/study/user/${user.id}`;
  } else if (user.organization === "Sponsor") {
    url = `/study/sponsor-user/${user.id}`;
  } else if (user.organization === "CDL" && user.role === "employee") {
    url = `/study/employee/${user.id}`;
  }

  const response = await instance.get(url);
  return response.data || [];
};

export const getAnalyticProtocols = async (studyId) => {
  if (!studyId) {
    return [];
  }

  const response = await instance.get(`/protocol/${studyId}`);
  return response.data || [];
};

export const runAnalyticQuery = async (filters) => {
  const response = await instance.post("/analytic", filters);
  return response.data;
};
